<template>
  <div class="Subscribe-Popup" @click.self="$emit('close')">
    <ButtonClose class="Subscribe-Popup__close" @click="$emit('close')" :type="'white-fill'" />
    <SubscriptionContent class="Subscribe-Popup__wrapper" @close="$emit('close')"/>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { onMounted, onBeforeUnmount } from 'vue';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName';
  //-------------------------
  import SubscriptionContent from '../SubscriptionContent/SubscriptionContent.vue';
  import ButtonClose from '@shared/UI/Buttons/ButtonClose/ButtonClose.vue';
  //-------------------------
  const store = useStore();
  const emit = defineEmits();
  //-------------------------
  onMounted(() => {
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.subscribtionPopup);
  })
  onBeforeUnmount(() => {
    emit("close");
    store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.subscribtionPopup);
  })
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>